app.factory('recipientService', function($http) {
    return {
        list: function(page, params) {
            return $http.get('/receiver?page=' + page, {
                params: params
            });
        },
        show: function(id) {
            return $http.get('/receiver/' + id);
        },
        create: function() {
            return $http.get('/receiver/create');
        },
        store: function(data) {
            return $http.post('/receiver', data);
        },
        edit: function(id) {
            return $http.get('/receiver/' + id + '/edit');
        },
        update: function(id, data) {
            return $http.put('/receiver/' + id, data);
        },
        delete: function(id) {
            return $http.delete('/receiver/' + id);
        },
        filters: function() {
            return $http.get('/receiver/filters');
        },
        unverified: function(page) {
            return $http.get('/receiver/unverified?page=' + page);
        },
        verify: function(ids) {
            return $http.post('/receiver/verify', ids);
        },
        renewMobileCode: function(recipients) {
            return $http.post('/receiver/renewmobilecode', recipients);
        },
        activate: function(ids) {
            return $http.post('/receiver/activate', ids);
        },
        spam: function(ids) {
            return $http.post('/receiver/spam', ids);
        },
        teryt: function(filter, query) {
            return $http.post('/receiver/teryt', {
                'filter': filter,
                'query': query
            })
        },
        printpdf: function(id) {
            return $http.get('/receiver/printpdf/' + id);
        },
        printpdfclear: function() {
            return $http.get('/receiver/printpdf');
        }
    };
});
